<script lang="ts">
	import TestimonialSection from '$lib/components/landing/TestimonialSection.svelte';
	import { testimonialMockData } from '../../testimonial-mock';
	import { BlurFade } from '$lib/components/magic/blur-fade';
	import TournamentTypes from './TournamentTypes.svelte';
	import SquadSection from './SquadSection.svelte';
	import VerifyActionsSection from './VerifyActionsSection.svelte';
	import WhatWeDoSection from './WhatWeDoSection.svelte';
	import WhoWeAreSection from './WhoWeAreSection.svelte';
	import SixPillarsSection from './SixPillarsSection.svelte';
	import BackToTop from '$lib/components/app/BackToTop.svelte';
	import Seo from '$lib/components/app/Seo.svelte';

	const testimonialData = testimonialMockData;
</script>

<Seo title="About" description="Learn more about our mission to save the planet through sports." />

<div class="flex flex-col bg-planet-gray max-w-7xl mx-auto px-6 md:px-12 overflow-hidden">
	<BlurFade delay={0} inView>
		<WhoWeAreSection />
	</BlurFade>

	<BlurFade delay={0.2} inView>
		<WhatWeDoSection />
	</BlurFade>

	<BlurFade delay={0.3} inView>
		<div class="py-12 md:py-24">
			<TournamentTypes />
		</div>
	</BlurFade>

	<BlurFade delay={0.4} inView>
		<div class="py-12 md:py-24">
			<SixPillarsSection />
		</div>
	</BlurFade>

	<BlurFade delay={0.5} inView>
		<div class="py-12 md:py-24">
			<TestimonialSection data={testimonialData} />
		</div>
	</BlurFade>

	<BlurFade delay={0.6} inView>
		<VerifyActionsSection />
	</BlurFade>

	<BlurFade delay={0.7} inView>
		<SquadSection />
	</BlurFade>
</div>

<BackToTop />
